<template>
  <div>
    <v-dialog
      v-model="DIALOG_ATIVO"
      persistent
      width="550"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
          <span>{{ editando ? "Editando" : "Cadastrando" }}</span>
          <v-spacer />
          <v-btn icon @click="fecharDialog" class="ml-n2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-3">
          <SysFornecedorAutocomplete
            v-model="editedItem.fornecedores"
            label="Selecione o Fornecedor*"
            outlined
            multiple
            cor_loading="primary"
            :disabled="editedItem.id > 0"
            :error-messages="fornecedorErros"
            @change="messageError = null"
          />

          <text-field-formatador
            v-model="editedItem.tempo_cobertura"
            label="Informe o Tempo de Cobertura Padrão *"
            outlined
            inteiro
            :remover-valor-irrelevante="true"
            :error-messages="tempoCoberturaPadraoErros"
            @focus="$event.target.select()"
            @keyup.enter="salvar()"
          />

          <text-field-formatador
            v-model="editedItem.cobertura_estoque_curva_a"
            label="Informe o Tempo de Cobertura Curva A"
            outlined
            inteiro
            :remover-valor-irrelevante="true"
            :error-messages="tempoCoberturaCurvaAErros"
            @focus="$event.target.select()"
            @keyup.enter="salvar()"
          />

          <text-field-formatador
            v-model="editedItem.cobertura_estoque_curva_b"
            label="Informe o Tempo de Cobertura Curva B"
            outlined
            inteiro
            :remover-valor-irrelevante="true"
            :error-messages="tempoCoberturaCurvaBErros"
            @focus="$event.target.select()"
            @keyup.enter="salvar()"
          />

          <text-field-formatador
            v-model="editedItem.cobertura_estoque_curva_c"
            label="Informe o Tempo de Cobertura Curva C"
            outlined
            inteiro
            :remover-valor-irrelevante="true"
            :error-messages="tempoCoberturaCurvaCErros"
            @focus="$event.target.select()"
            @keyup.enter="salvar()"
          />
        </v-card-text>

        <v-card-actions class="d-flex mt-n5">
          <v-spacer />
          <v-btn text color="primary" @click="salvar()"> salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysFornecedorAutocomplete from "../../../utils/crud/SysFornecedorAutocomplete.vue";
import TextFieldFormatador from "../../../utils/TextFieldFormatadorDeValor.vue";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import TempoCoberturaPorFornecedor from "../../../../api/compras/TempoCoberturaPorFornecedor";

export default {
  name: "DialogCurvasCompras",
  components: {
    TextFieldFormatador,
    SysFornecedorAutocomplete,
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    itemParaEdicao: {
      type: Object,
    },
  },
  data: () => ({
    messageError: null,
    editedItem: {
      id: "",
      fornecedores: [],
      tempo_cobertura: "",
      cobertura_estoque_curva_a: 0,
      cobertura_estoque_curva_b: 0,
      cobertura_estoque_curva_c: 0,
    },
  }),
  watch: {
    itemParaEdicao(item) {
      const { id, idfornecedor, tempo_cobertura, cobertura_estoque_curva_a, cobertura_estoque_curva_b, cobertura_estoque_curva_c } =
        item;
      this.editedItem = Object.assign(
        {},
        { id, fornecedores: [idfornecedor], tempo_cobertura, cobertura_estoque_curva_a, cobertura_estoque_curva_b, cobertura_estoque_curva_c }
      );
    },
  },
  validations: {
    messageError: {
      duplicated() {
        return this.messageError === null;
      },
    },
    editedItem: {
      fornecedores: {
        required,
      },
      tempo_cobertura: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(99999999),
      },
      cobertura_estoque_curva_a: {
        minValue: minValue(0),
        maxValue: maxValue(99999999),
      },
      cobertura_estoque_curva_b: {
        minValue: minValue(0),
        maxValue: maxValue(99999999),
      },
      cobertura_estoque_curva_c: {
        minValue: minValue(0),
        maxValue: maxValue(99999999),
      },
    },
  },
  computed: {
    editando() {
      return this.editedItem.id && this.editedItem.id > 0;
    },
    DIALOG_ATIVO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      },
    },
    fornecedorErros() {
      const errors = [];
      if (!this.$v.editedItem.fornecedores.$dirty) return errors;
      !this.$v.editedItem.fornecedores.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    tempoCoberturaPadraoErros() {
      const errors = [];
      if (!this.$v.editedItem.tempo_cobertura.$dirty) return errors;
      !this.$v.editedItem.tempo_cobertura.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.tempo_cobertura.minValue &&
        errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.tempo_cobertura.maxValue &&
        errors.push("Valor máximo é 99.999.999.");
      return errors;
    },
    tempoCoberturaCurvaAErros() {
      const errors = [];
      if (!this.$v.editedItem.cobertura_estoque_curva_a.$dirty) return errors;
      !this.$v.editedItem.cobertura_estoque_curva_a.minValue &&
        errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.cobertura_estoque_curva_a.maxValue &&
        errors.push("Valor máximo é 99.999.999.");
      return errors;
    },
    tempoCoberturaCurvaBErros() {
      const errors = [];
      if (!this.$v.editedItem.cobertura_estoque_curva_b.$dirty) return errors;
      !this.$v.editedItem.cobertura_estoque_curva_b.minValue &&
        errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.cobertura_estoque_curva_b.maxValue &&
        errors.push("Valor máximo é 99.999.999.");
      return errors;
    },
    tempoCoberturaCurvaCErros() {
      const errors = [];
      if (!this.$v.editedItem.cobertura_estoque_curva_c.$dirty) return errors;
      !this.$v.editedItem.cobertura_estoque_curva_c.minValue &&
        errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.cobertura_estoque_curva_c.maxValue &&
        errors.push("Valor máximo é 99.999.999.");
      return errors;
    },
  },
  methods: {
    salvar() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          TempoCoberturaPorFornecedor.store(headers, this.editedItem)
            .then((response) => {
              const { token, messageError } = response.data;
              localStorage.token = token;

              if (!messageError) {
                this.fecharDialog();
                this.$emit("atualizar-lista", true);
              } else {
                this.messageError = messageError;
              }
            })
            .catch(() => this.Helpers.logout())
        );
      }
    },
    fecharDialog() {
      this.DIALOG_ATIVO = false;
      this.messageError = null;
      this.$v.$reset();
      this.editedItem = {
        id: "",
        fornecedores: [],
        tempo_cobertura: "",
        cobertura_estoque_curva_a: 0,
        cobertura_estoque_curva_b: 0,
        cobertura_estoque_curva_c: 0,
      };
    },
  },
};
</script>

<style>
</style>
